var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoUsageData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 33,
    viewBox: "0 0 48 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9492 0C30.1069 0 35.6843 3.72677 38.0566 9.47949L38.4854 10.4805L39.5459 10.7305C44.4921 11.9311 47.9492 16.3331 47.9492 21.4355L48 21.4102C48 27.5381 43.079 32.4911 36.9971 32.4912H35.7871L31.6748 25.3691C33.7252 23.8142 35.0507 21.3529 35.0508 18.5811C35.0505 13.8781 31.2381 10.0647 26.5352 10.0645C21.8321 10.0646 18.0188 13.878 18.0186 18.5811C18.0186 23.2842 21.832 27.0965 26.5352 27.0967C27.3568 27.0966 28.1507 26.9779 28.9023 26.7607L32.2119 32.4922H32.9863C22.5395 32.4964 19.5149 32.5166 15.293 32.5166H11.0029C4.92101 32.5165 0 27.5635 0 21.4355C3.70473e-05 16.3332 3.45723 11.9312 8.40332 10.7305L9.43848 10.4805L9.86719 9.47949C12.2646 3.72677 17.7916 0.000123905 23.9492 0Z",
    fill: "url(#paint0_linear_2237_1325)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5352 13.1611C29.5279 13.1613 31.9539 15.5884 31.9541 18.5811C31.9539 21.5738 29.5279 23.9998 26.5352 24C23.5423 23.9999 21.1154 21.5739 21.1152 18.5811C21.1155 15.5883 23.5424 13.1613 26.5352 13.1611Z",
    fill: "url(#paint1_linear_2237_1325)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2237_1325",
    x1: -0.477363,
    y1: 8.73149,
    x2: 47.2879,
    y2: 20.2655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394231,
    stopColor: "#BCB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7C68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2237_1325",
    x1: -0.477363,
    y1: 8.73149,
    x2: 47.2879,
    y2: 20.2655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394231,
    stopColor: "#BCB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7C68FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoUsageData);
export default __webpack_public_path__ + "static/media/ic-no-usage-data.14f9d05f3a3a702992e50fe426854e03.svg";
export { ForwardRef as ReactComponent };